import AuthSignInView from "Components/Auth/AuthSignInView";
import { useSubscribeToCompany } from "Components/Company/hooks/useCompany";
import { useSubscribeToCompanySetting } from "Components/CompanySetting/hooks/useCompanySetting";
import { useSubscribeToProfile } from "Components/Profile/hooks/useProfile";
import { useSubscribeToProfileLimits } from "Components/ProfileLimit/hooks/useProfileLimits";
import { useVersionInterval } from "Providers/VersionProvider";
import { InitializationProvider } from "Providers/InitializationProvider";
import AppView from "Views/AppView";
import LoadingIndicator from "Views/LoadingIndicator";
import React, { FC } from "react";
import { AuthErrorView } from "./AuthErrorView";
import { useAuthDocsError } from "./hooks/useAuthDocsError";
import { useAuthUser, useSubscribeToAuthUser } from "./hooks/useAuthUser";
import { useIsInitializingAuthDocs } from "./hooks/useIsInitializingAuthDocs";

interface Props {
	initialDate?: string;
	initialView?: string;
}

const AuthView: FC<Props> = ({ initialDate, initialView }) => {
	useVersionInterval();
	useSubscribeToAuthUser();
	useSubscribeToProfile();
	useSubscribeToCompany();
	useSubscribeToCompanySetting();
	useSubscribeToProfileLimits();

	const hasUser = useAuthUser((state) => !!state.user);
	const isInitializingAuthUser = useAuthUser((state) => state.isInitializing);
	const authUserError = useAuthUser((state) => state.error);
	const isInitializingAuthDocs = useIsInitializingAuthDocs();
	const authDocsError = useAuthDocsError();
	const error = authUserError || authDocsError;

	if (error) {
		return <AuthErrorView error={error} />;
	}

	if (isInitializingAuthUser) {
		return <LoadingIndicator />;
	}

	if (!hasUser) {
		return <AuthSignInView />;
	}

	if (isInitializingAuthDocs) {
		return <LoadingIndicator />;
	}

	return (
		<InitializationProvider initialDate={initialDate} initialView={initialView}>
			<AppView />
		</InitializationProvider>
	);
};

export default AuthView;
